export function formatPercent(valor) {
  const num = Number(valor);

  if (num % 1 === 0) {
    return `${num.toFixed(0)}%`;
  } else {
    return `${num}%`;
  }
}
